/**
 * §3.4 — granularidad fija.
 *
 * Cada tenant define `slot_min` (default 15). Toda duracion de tramo debe ser
 * multiplo: el motor rechaza servicios con duraciones irregulares en vez de
 * devolver cero slots en silencio (T03, caso 6).
 */
export class DuracionIrregularError extends Error {
    duracionMin;
    slotMin;
    constructor(duracionMin, slotMin) {
        super(`La duracion ${duracionMin} min no es multiplo de la granularidad ${slotMin} min`);
        this.duracionMin = duracionMin;
        this.slotMin = slotMin;
        this.name = 'DuracionIrregularError';
    }
}
export function esMultiploDeSlot(duracionMin, slotMin) {
    if (!Number.isInteger(duracionMin) || !Number.isInteger(slotMin))
        return false;
    if (slotMin <= 0 || duracionMin <= 0)
        return false;
    return duracionMin % slotMin === 0;
}
/** Lanza si alguna duracion de tramo es irregular. Se llama antes de calcular slots. */
export function exigirMultiplosDeSlot(duracionesMin, slotMin) {
    for (const duracion of duracionesMin) {
        if (!esMultiploDeSlot(duracion, slotMin)) {
            throw new DuracionIrregularError(duracion, slotMin);
        }
    }
}
/** Cantidad de slots que ocupa una duracion. Presupone que ya paso `exigirMultiplosDeSlot`. */
export function slotsQueOcupa(duracionMin, slotMin) {
    if (!esMultiploDeSlot(duracionMin, slotMin)) {
        throw new DuracionIrregularError(duracionMin, slotMin);
    }
    return duracionMin / slotMin;
}
//# sourceMappingURL=granularidad.js.map